import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "daysField", "rechargesField"];

  connect() {
    if (this.hasSelectTarget) this.toggle();
  }

  toggle() {
    const select =
      this.selectTarget.tagName === "SELECT"
        ? this.selectTarget
        : this.selectTarget.querySelector("select");
    if (!select) return;

    const isRecharges = select.value.startsWith("recharges");

    if (this.hasDaysFieldTarget) {
      this.daysFieldTarget.style.display = isRecharges ? "none" : "";
    }
    if (this.hasRechargesFieldTarget) {
      this.rechargesFieldTarget.style.display = isRecharges ? "" : "none";
    }
  }
}
